import { Button } from '@shared/ui/src/components/buttons/Button';
import { Plus } from 'lucide-react';
import { useDataManagementContext } from '../../../hooks/useDataManagementContext';

export function DataManagementHeader() {
  const { title, permissions, onSelectItem, onOpenChange } = useDataManagementContext();
  
  const canCreate = permissions.verbs?.create;
  
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold">{title}</h1>
      {canCreate && (
        <Button 
          onClick={() => {
            onSelectItem(null);
            onOpenChange(true);
          }}
        >
          <Plus className="mr-2 h-4 w-4" />
          Add {title.slice(0, -1)}
        </Button>
      )}
    </div>
  );
} 